import React from 'react';
import { Section } from './ui/Section';
export const MethodSection = () => {
  return <Section darker data-id="element-117">
      <div className="max-w-4xl mx-auto" data-id="element-118">
        <div className="text-center mb-12" data-id="element-119">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white" data-id="element-120">
            EL MÉTODO APAGÓN MENTAL
          </h2>
          <h3 className="text-xl md:text-2xl text-accent-blue font-medium" data-id="element-121">
            La única forma de apagar la cabeza que funciona en 2 pasos simples
          </h3>
        </div>

        <div className="text-center text-lg text-gray-300 mb-16 max-w-2xl mx-auto" data-id="element-122">
          <p data-id="element-123">
            La mayoría intenta relajarte. Eso no alcanza. Primero necesitás
            vaciar lo que mantiene la cabeza encendida.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-124">
          <div className="bg-night-800 p-8 rounded-2xl border border-night-700 shadow-xl" data-id="element-125">
            <div className="w-12 h-12 bg-cta/20 rounded-full flex items-center justify-center text-cta font-bold text-xl mb-6" data-id="element-126">
              1
            </div>
            <h4 className="text-2xl font-bold text-white mb-4" data-id="element-127">
              PARTE 1: DESCARGA
            </h4>
            <p className="text-gray-300 leading-relaxed" data-id="element-128">
              Sacás de tu cabeza todo lo que la sigue manteniendo prendida.
              Cuando tu cerebro siente que todo está registrado, deja de
              repetírtelo. Baja la guardia.
            </p>
          </div>

          <div className="bg-night-800 p-8 rounded-2xl border border-night-700 shadow-xl" data-id="element-129">
            <div className="w-12 h-12 bg-accent-blue/20 rounded-full flex items-center justify-center text-accent-blue font-bold text-xl mb-6" data-id="element-130">
              2
            </div>
            <h4 className="text-2xl font-bold text-white mb-4" data-id="element-131">
              PARTE 2: APAGADO
            </h4>
            <p className="text-gray-300 leading-relaxed" data-id="element-132">
              Usás técnicas físicas simples para bajar el cuerpo. Para frenar el
              espiral. Para darle al sistema nervioso la señal de que puede
              descansar.
            </p>
          </div>
        </div>

        <div className="bg-cta p-8 md:p-10 rounded-3xl text-center mb-12 shadow-[0_0_40px_rgba(108,99,255,0.3)]" data-id="element-133">
          <p className="text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-134">
            PRIMERO DESCARGÁS. DESPUÉS APAGÁS.
          </p>
          <p className="text-white/80 text-lg" data-id="element-135">
            Ese orden es el que hace que funcione.
          </p>
        </div>

        <div className="text-center max-w-2xl mx-auto" data-id="element-136">
          <p className="text-lg text-gray-400 italic" data-id="element-137">
            <strong className="text-white not-italic" data-id="element-138">
              Por qué es diferente:
            </strong>{' '}
            La mayoría intenta apagar la cabeza sin descargarla primero. Es como
            apagar un motor sin sacarle la nafta.
          </p>
        </div>
      </div>
    </Section>;
};